/**
 * What an answer box can be, in one place.
 *
 * The box, its action bar and the canvas all read from here, so a mode cannot
 * exist in one and not the others.
 */
export const ANSWER_MODES = {
  TYPE: "type",
  PEN: "pen",
};

/** The label and icon the mode toggle shows: it names where you are going,
 *  not where you are, which is what the design asks for. */
export const MODE_TOGGLE = {
  [ANSWER_MODES.TYPE]: { to: ANSWER_MODES.PEN, label: "Switch to pen" },
  [ANSWER_MODES.PEN]: { to: ANSWER_MODES.TYPE, label: "Type Answer" },
};

/** Things the add button offers that are not a figure from the question. */
export const ADD_ACTIONS = {
  UPLOAD: "upload",
  FORMULA: "formula",
};

/** A dropped-in image starts this wide; the student can still drag it. */
export const INSERTED_IMAGE_WIDTH = 260;

/** The dotted ground the canvas is drawn on (Figma 215:187). */
export const CANVAS_DOT_SIZE = 1;
export const CANVAS_DOT_GAP = 14;
